/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable css-modules/no-unused-class */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '@ryanar/react-auth-provider';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import { ContactUsModal } from 'components/modals';
import ComplaintForm from '../Help/ComplaintForm';

import styles from './Complaint.module.css';

const Complaint = () => {
  const { authenticated } = React.useContext(AuthContext);

  const history = useHistory();
  const goBack = () => history.goBack();

  const [isContactsModalOpen, setContactsModalOpen] = useState(false);
  const closeContactsModal = () => setContactsModalOpen(false);

  return (
    <DashboardCard className={!authenticated ? styles.container : undefined}>
      <ContactUsModal open={isContactsModalOpen} onClose={closeContactsModal} />
      <NavigationTitle
        to="/complaint"
        onClick={goBack}
        layoutType={authenticated ? LayoutType.dashboard : LayoutType.support}
      >
        Customer Complaint
      </NavigationTitle>
      <ComplaintForm />
    </DashboardCard>
  );
};

export default Complaint;
